module.exports = __webpack_public_path__ + "static/media/mysql.3ed8f195.jpg";